import { Route } from '@angular/router';

export const industryRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./list/industry-list.component').then(
            (m) => m.IndustryListComponent
          ),
      },
      {
        path: 'hierarchy',
        loadComponent: () =>
          import('./hierarchy/industry-hierarchy.component').then(
            (m) => m.IndustryHierarchyComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./detail/industry-detail.component').then(
            (m) => m.IndustryDetailComponent
          ),
      },
      {
        path: 'edit/:industryId',
        loadComponent: () =>
          import('./detail/industry-detail.component').then(
            (m) => m.IndustryDetailComponent
          ),
      },
    ],
  },
];
